import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Case, CaseDocument, CaseType } from 'src/app/models/case';
import { PropertyOffice } from 'src/app/models/propertyOffice';
import { CaseCoverageComponent } from '../case-coverage/case-coverage.component';
import { CaseProofsComponent } from '../case-proofs/case-proofs.component';
import { ProductService } from 'src/app/models/productService';
import { CaseRenewalProofsComponent } from '../case-renewal-proofs/case-renewal-proofs.component';
import { TrademarkService } from 'src/app/services/trademark.service';
import _ from 'lodash';

export interface ClassWithPSAndDocuments {
  classNumber: number;
  expanded?: boolean;
  productsServices: PSWithDocuments[]
}

export interface PSWithDocuments {
  ref: string;
  label?: string;
  expanded?: boolean;
  documents?: CaseDocument[]
}

@Component({
  selector: 'app-case-information',
  templateUrl: './case-information.component.html',
  styleUrls: ['./case-information.component.scss']
})
export class CaseInformationComponent implements AfterViewInit, OnChanges {
  public CaseType = CaseType;

  @Input() case?: Case;
  @Input() count: number = 0;
  @Input() propertyOffice?: PropertyOffice;
  @Input() mode: 'CONSULTATION' | 'EDITION' = 'CONSULTATION';
  @Output() toProofs = new EventEmitter<any>();

  @Input() productsServices?: ProductService[];
  @Input() trademarkProductsServices?: ProductService[];
  classes: ClassWithPSAndDocuments[] = [];

  @ViewChild('caseCoverage') caseCoverage?: CaseCoverageComponent;
  @ViewChild('caseRenewalProofs') caseRenewalProofs?: CaseRenewalProofsComponent;

  constructor(
    private trademarkService: TrademarkService
  ) {

  }

  async ngAfterViewInit() {
    // await this.retrieveProductsServices();
    // if (this.case?.type === CaseType.RENEWAL_MAINTENANCE) {
    //   this.populateClassesAndPs();
    // };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes &&
      (changes['productsServices'] && !_.isEqual(changes['productsServices']['previousValue'], changes['productsServices']['currentValue']))
      || (changes['trademarkProductsServices'] && !_.isEqual(changes['trademarkProductsServices']['previousValue'], changes['trademarkProductsServices']['currentValue']))) {
      if (this.case?.type === CaseType.RENEWAL_MAINTENANCE) {
        this.populateClassesAndPs();
      };
    }
  }

  refreshCoverage() {
    if (this.caseCoverage) {
      this.caseCoverage.aggregateDocuments();
    }
  }

  // async retrieveProductsServices() {
  //   if (this.case && this.case.trademark && this.case.trademark.ref) {
  //     this.trademarkProductsServices = await this.trademarkService.retrieveProductsAndServices(this.case.trademark.ref);
  //     this.productsServices = this.trademarkProductsServices.filter((ps) => ps._id && this.case?.productsServices?.map((cps) => cps.ref).includes(ps._id))
  //   }
  // }

  populateClassesAndPs() {
    if (this.case && this.case.productsServices) {
      if (this.case.productsServices.length === 0 && this.trademarkProductsServices) {
        this.case.productsServices = this.trademarkProductsServices.filter((ps) => this.case?.niceClassification.includes(ps.classNumber)).map((ps) => ({
          ref: ps._id!,
          label: ps.label,
          classNumber: ps.classNumber,
          trademark: ps.trademark?.ref!
        }));
      }
      this.case.productsServices.forEach((ps) => {
        const foundClass = this.classes.find(c => c.classNumber === ps.classNumber);
        if (foundClass) {
          const foundPs = foundClass.productsServices.find((cps) => cps.ref === ps.ref);
          if (!foundPs) {
            foundClass.productsServices.push({
              ref: ps.ref,
              label: ps.label,
              expanded: false,
              documents: []
            });
            foundClass.productsServices.sort((a, b) => (a.label || '').localeCompare(b.label || ''))
          }
        } else {
          this.classes.push({
            classNumber: ps.classNumber,
            expanded: false,
            productsServices: [
              {
                ref: ps.ref,
                label: ps.label,
                expanded: false,
                documents: []
              }
            ]
          })
        }
      })
      this.caseRenewalProofs?.populateClassesAndPS();
    }
  }

}
